import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchRepatriationsTransactionsDelete from '../../api/InternalRepatriationsTransactionsDeleteAPI';
import { REPATRIATIONS_TRANSACTIONS_DELETE_REQUEST } from '../actions/types/InternalRepatriationsTransactionsDeleteActionsTypes';
import { deleteRepatriationsTransactionsDeleteSuccessActionCreator, deleteRepatriationsTransactionsDeleteFailureActionCreator } from '../actions/InternalRepatriationsTransactionsDeleteActions';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';

function* doRepatriationsTransactionsDeleteWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchRepatriationsTransactionsDelete, action.payload);
    yield put(deleteRepatriationsTransactionsDeleteSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.centerinitiatedrepatriationstransactions.delete.success'),
    }));
  } catch (error) {
    yield put(deleteRepatriationsTransactionsDeleteFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.centerinitiatedrepatriationstransactions.delete.failure'),
    }));
  }
}

function* doRepatriationsTransactionsDeleteWatcher() {
  yield takeLatest(REPATRIATIONS_TRANSACTIONS_DELETE_REQUEST, doRepatriationsTransactionsDeleteWorker);
}

export default doRepatriationsTransactionsDeleteWatcher;
